// extracted by mini-css-extract-plugin
export default {"link":"Hd4PGa","timeAgo":"wouVzW","avatar":"j132ID","directionIcon":"RuqB6D","text":"yaG1NR"};